import React from 'react';
import type { FormikProps } from 'formik/dist/types';
import type { FormValues } from 'src/components/AuthNew/components/RegistrationForm/types';
import { FormFields } from 'src/components/AuthNew/components/RegistrationForm/types';
import { Input } from 'src/components/AuthNew/components/Input';
import type { SetSharedState, SharedState } from 'src/components/AuthNew/types';
import { useTranslation } from '@lt/localization';
import classnames from 'classnames';
import { registrationErrorMap } from '../../helpers';
import { PhoneInput } from '../../../LoginForm/components';
import styles from './content.module.css';

type Props = {
  isMobile?: boolean;
  disablePhone?: boolean;
  disableEmail?: boolean;
  sharedState?: SharedState;
  setSharedState?: SetSharedState;
  backToLoginForm?: (value?: string) => void;
  errorCodes?: string;
  isStyleAsMobile?: boolean;
} & FormikProps<FormValues>;

export const Content = ({
  isMobile,
  disablePhone,
  disableEmail,
  backToLoginForm,
  setSharedState,
  sharedState,
  errorCodes,
  isStyleAsMobile,
}: Props) => {
  const { t } = useTranslation();

  const renderAppendAddon = (val: string) => {
    if (errorCodes && Object.keys(registrationErrorMap).includes(errorCodes))
      return (
        <span
          className={styles.appendAddon}
          role="button"
          tabIndex={0}
          onClick={() => backToLoginForm && backToLoginForm(val)}
          onKeyDown={() => backToLoginForm && backToLoginForm(val)}
        >
          {t('checkout.passwordForm.login')}
        </span>
      );
    return null;
  };

  return (
    <>
      <div
        className={classnames(styles.row, {
          [styles.rowMobile]: isMobile || isStyleAsMobile,
        })}
      >
        <Input
          className={styles.input}
          name={FormFields.Name}
          header={t('checkout.registrationForm.name.header')}
          placeholder={t('checkout.registrationForm.name.placeholder')}
          showSuccessIcon={false}
        />
        <Input
          className={styles.input}
          name={FormFields.Surname}
          header={t('checkout.registrationForm.surname.header')}
          placeholder={t('checkout.registrationForm.surname.placeholder')}
          showSuccessIcon={false}
        />
      </div>
      <div
        className={classnames(styles.row, {
          [styles.rowMobile]: isMobile || isStyleAsMobile,
        })}
      >
        <Input
          className={styles.input}
          name={FormFields.Email}
          header={t('checkout.registrationForm.email.header')}
          placeholder={t('checkout.registrationForm.email.placeholder')}
          showSuccessIcon={false}
          nativeInputProps={{
            disabled: disableEmail,
          }}
          type="email"
          renderAppendAddon={renderAppendAddon}
          hint={t('checkout.registrationForm.email.hint')}
        />

        <PhoneInput
          className={styles.phoneInput}
          setSharedState={setSharedState}
          sharedState={sharedState}
          name={FormFields.Phone}
          inputProps={{
            disabled: disablePhone,
            type: 'tel',
          }}
          renderAppendAddon={renderAppendAddon}
          hint={t('checkout.registrationForm.phone.hint')}
        />
      </div>
    </>
  );
};
